import { ReducerRegistry } from 'store';
import {
  GET_ONBOARDING_DATA,
  UPDATE_OWNER_INFO,
  UPDATE_CONTACT_INFO,
  UPDATE_BUSINESS_DOCS,
  UPDATE_BUSINESS_LOCATION,
  UPDATE_VERIFICATION_STATUS,
  FETCH_VERIFICATION_TYPES,
} from '../types';

const init_State = {
  businessInformation: { gender: '', dateOfBirth: '', profilePicture: '' },
  contactInformation: {
    address: '',
    state: '',
    lga: '',
    utilityBill: '',
    bvn: '',
    idType: '',
    idNumber: '',
    idImage: '',
  },
  businessDocuments: {
    logo: '',
    registeredName: '',
    description: '',
    type: '',
    category: '',
    cac: '',
  },
  businessLocation: { address: '', state: '', lga: '' },
  bvnVerified: false,
  idVerified: false,
  verificationTypes: [],
};

export const state = ReducerRegistry.register(
  'onboarding',
  (state = init_State, action) => {
    switch (action.type) {
      case GET_ONBOARDING_DATA:
        const {
          businessInformation,
          contactInformation,
          businessDocuments,
          businessLocation,
        } = action.payload;
        return {
          ...state,
          businessInformation:
            businessInformation === null
              ? { gender: '', dateOfBirth: '', profilePicture: '' }
              : businessInformation,
          contactInformation:
            contactInformation === null
              ? {
                  address: '',
                  state: '',
                  lga: '',
                  utilityBill: '',
                  bvn: '',
                  idType: '',
                  idNumber: '',
                  idImage: '',
                }
              : contactInformation,
          businessDocuments:
            businessDocuments === null
              ? {
                  logo: '',
                  registeredName: '',
                  description: '',
                  type: '',
                  category: '',
                  cac: '',
                }
              : businessDocuments,
          businessLocation:
            businessLocation === null
              ? { address: '', state: '', lga: '' }
              : businessLocation,
          bvnVerified: true,
          idVerified: true,
        };

      case UPDATE_OWNER_INFO:
        return {
          ...state,
          businessInformation: {
            ...state.businessInformation,
            [action.payload.target]: action.payload.value,
          },
        };
      case UPDATE_CONTACT_INFO:
        return {
          ...state,
          contactInformation: {
            ...state.contactInformation,
            [action.payload.target]: action.payload.value,
          },
        };
      case UPDATE_BUSINESS_DOCS:
        return {
          ...state,
          businessDocuments: {
            ...state.businessDocuments,
            [action.payload.target]: action.payload.value,
          },
        };
      case UPDATE_BUSINESS_LOCATION:
        return {
          ...state,
          businessLocation: {
            ...state.businessLocation,
            [action.payload.target]: action.payload.value,
          },
        };
      case UPDATE_VERIFICATION_STATUS:
        return {
          ...state,
          [action.payload.target]: action.payload.value,
        };
      case FETCH_VERIFICATION_TYPES:
        return {
          ...state,
          verificationTypes: action.payload,
        };
      default:
        return state;
    }
  },
);
